<template>
  <div class="my-finance-transfer">
    <h2 class="topTitle">主账户额度</h2>
    <div class="topCount">
      <div class="mainGold">
        <span class="colord00">￥</span>
        <span class="goldNum">{{userInfo.totalBalance}}</span>
        <span class="goldUnit">元</span>
        <i :class="['el-icon-refresh-right',{annkrotate1:isRotate}]" @click="getuserMoney"></i>
      </div>
      <div class="button" @click="$nkhttp.oneKeyBalance()">资金一键归户</div>
    </div>
    <div class="myTitle3">选择游戏平台</div>
    <ul class="gamelist el-row borbot">
      <li v-for="game in userInfo.totalBalanceDetail" :key="game.vendorId">
        <p class="gamep1">
          {{game.vendorName}}
          <i class="el-icon-refresh-right"></i>
        </p>
        <p class="gamep2">
          余额：
          <span>{{game.totalMoney}}</span>
        </p>
        <p class="gamep3" v-if="false">
          <span>开通</span>
        </p>
      </li>
    </ul>
    <div class="myTitle3">转账额度</div>
    <div class="numbox">
      <el-input placeholder="户内转账最低1元，只能为整数" v-model="input2">
        <el-button slot="append">全部转入</el-button>
      </el-input>
      <span>请输入正确金额,且只能是整数！</span>
    </div>
    <div class="bottom">
      <p class="btnConfirm bottomp1">转到主账户</p>
      <p class="btnConfirm bottomp2">转到游戏平台</p>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      input2: "",
      isRotate:false
    };
  },
    computed: {
    ...mapGetters(["userInfo"]),
  },
  methods:{
    getuserMoney(){
      this.isRotate=true;
      this.$nkhttp.getuserMoney(res=>{
        if(res.code==0){
           this.$message.success("更新成功");
        }else{
          this.$message.error(res.msg || '请求失败');
        }
        this.isRotate=false;
      },false,true)
    }
  }
};
</script>
<style lang="scss" scoped>
    @import url('../../../assets/css/common.css');
.my-finance-transfer {
  .topTitle {
    font-size: 13px;
    color: #333;
    font-weight: 500;
    line-height: 30px;
  }
  .topCount {
    border-bottom: 1px solid #e8e8e8;
    margin-top: 2px;
    padding-bottom: 15px;
    .mainGold {
      border: 1px solid #e8e8e8;
      box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.05);
      background: #f5f5f5;
      height: 30px;
      padding: 7px 8px;
      border-radius: 8px;
      font-size: 14px;
      display: inline-block;
      .goldNum {
        font-size: 20px;
        color: #d00;
        margin: 0 8px;
      }
      .goldUnit {
        color: #444;
      }
      i {
        font-size: 18px;
        color: #bbb;
        font-weight: bold;
        margin-left: 40px;
        cursor: pointer;
      }
    }
    .button {
      border: 1px solid #dcdcdc;
      background: #fafafa;
      box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.06);
      height: 44px;
      line-height: 44px;
      padding: 0 15px;
      border-radius: 8px;
      margin: 2px 0 0 8px;
      color: #444;
      font-size: 13px;
      font-weight: 400;
      display: inline-block;
      cursor: pointer;
      &:hover {
        border-color: #ff3a2b;
        background: #ff3a2b;
        color: #fff;
        box-shadow: 1px 2px 4px rgba(220, 0, 0, 0.2);
        opacity: 0.8;
      }
    }
  }
  .myTitle3 {
    margin: 20px 0;
  }
  .borbot {
    padding-bottom: 25px;
    border-bottom: 1px solid #e8e8e8;
  }
  .numbox {
    .el-input {
      width: 342px;
      box-shadow: 2px 2px 1px rgba(0,0,0,.06), inset 1px 1px 3px rgba(0,0,0,.06);
    }
    span {
      margin-left: 20px;
      color: #ff3a2b;
    }
  }
  .bottom {
    padding-top: 15px;
    p {
      line-height: 46px;
      width: 107px;
    }
    .bottomp1 {
      background: #303030;
    }
    .bottomp2 {
      background: #ff3a2b;
      margin-left: 5px;
    }
  }
}
</style>